import { noop } from 'lodash-es';
export const makeCoalescingRunner = (job)=>{
    const state = {
        isRunning: false,
        isRerunRequested: false
    };
    const runUntilSettled = async ()=>{
        state.isRerunRequested = false;
        await job().catch(noop);
        if (state.isRerunRequested) {
            return runUntilSettled();
        }
        state.isRunning = false;
        return undefined;
    };
    return {
        request: ()=>{
            if (state.isRunning) {
                state.isRerunRequested = true;
            } else {
                state.isRunning = true;
                void runUntilSettled();
            }
        }
    };
};
